import { render, staticRenderFns } from "./WaiterDashboard.vue?vue&type=template&id=754423d8&scoped=true&"
import script from "./WaiterDashboard.vue?vue&type=script&lang=js&"
export * from "./WaiterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./WaiterDashboard.vue?vue&type=style&index=0&id=754423d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754423d8",
  null
  
)

export default component.exports